import React from "react";
// import { Link } from "gatsby";

import Layout from "../components/layout";
import SEO from "../components/seo";

import CompanyLinks from "../components/companyLinks";

import {
  Card,
  // CardHeader,
  // CardBody,
  // Button,
  // CardTitle,
  CardText
  // CardImg
} from "reactstrap";

const ContactPage = () => (
  <Layout>
    <SEO title="Contact" />
    <div className="container">
      <h1 className="d-block text-center display-3">Contact</h1>

      <div className="d-block text-center mt-3">
        <p className="lead">
          We would love to hear from you. <br />
          Please feel free to contact us to further discuss your requirements.
        </p>
      </div>
      <div className="row justify-content-md-center">
        {/* <div className="col col-md-2" /> */}
        <div className="col-md-auto">
          <Card className="p-4 border border-dark text-center mb-4">
            <CardText>
              <strong>Tel:</strong> 01202 022487
              <br />
              <br />
              <strong>Email:</strong>{" "}
              <a
                href="mailto:mail@sturminster.co.uk"
                // style={{
                //   textDecoration: "none",
                //   color: "white"
                // }}
              >
                mail@sturminster.co.uk{" "}
              </a>{" "}
            </CardText>

            <CardText>
              <strong>Address:</strong> <br />
              Sturminster UK Ltd <br />
              26 Fulwood Avenue <br />
              Bearwood <br />
              Bournemouth <br />
              Dorset <br />
              BH11 9NJ
            </CardText>
          </Card>
        </div>
        {/* <div className="col col-md-2" /> */}
      </div>
    </div>
    <CompanyLinks />
  </Layout>
);

export default ContactPage;
